export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const dashboardBackground = require("../assets/DarkBgImage.png");
export const lightBackground = require("../assets/lightBg.png");
export const logo = require("../assets/logo.png");
export const view=require('../assets/view_.svg')
export const darkView=require('../assets/dark_view.svg')
export const RightIcon=require('../assets/RightIcon.svg')